<template>
  <div id="auth">
  </div>
</template>

<script>
//  import uiAuthConfig from '@/classes/Auth.js'
import firebaseApp from '@/classes/Db.js'
//  import firebaseui from 'firebaseui'

export default {
  name: 'auth',
  data () {
    return {
      msg: 'test'
    }
  },
  computed: {
    showAuth () {
      return this.$store.state.showAuth
    },
    user () {
      return this.$store.state.user
    }
  },
  methods: {
  },
  watch: {
  },
  mounted () {
    /* let user = firebaseApp.auth().currentUser
    if (user) {
      this.$store.commit('updateUser', user)
      if (user !== null && 'uid' in user) {
        this.$store.dispatch('startGettingNotices')
        this.$store.dispatch('startVoting')
        this.$store.dispatch('fetchUserPhotosAndScore')
        this.$store.dispatch('fetchUserVisitedSpots')
      }
    } else {
    } */
    firebaseApp.auth().onAuthStateChanged(user => {
      //  console.log('state changed', user)
      this.$store.commit('updateUserCheck', true)
      this.$store.commit('updateUser', user)
      if (user !== null && 'uid' in user) {
        this.$store.dispatch('startGettingNotices')
        //  this.$store.dispatch('startVoting')
        this.$store.dispatch('fetchUserPhotosAndScore')
        //  this.$store.dispatch('fetchUserVisitedSpots')
        this.$store.dispatch('fetchAllSpotsForUser')
        this.$store.dispatch('fetchHighscore')
      }
      //  console.log('user changed', user.uid)
    })
  },
  beforeDestroy () {
    //  ui.reset()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// Auth.vue?fb80295e